<template>
  <section
    class="radio-slider-container"
    :class="{ active: comboItems.isActive }"
    @click="openHandler"
    :style="comboItems.titleStyle"
  >
    <div class="select-title">
      <span class="highlight gradient">{{ $t(comboItems.title) }}</span>
    </div>
    <div
      :style="{ visibility: comboItems.isActive ? 'hidden' : 'unset' }"
      class="select-open"
    >
      <img
        src="@/assets/images/icons/arrow_bottom_ico.svg"
        class="select-ico"
      />
    </div>
  </section>

  <section
    class="show-open-container"
    :class="{ show: comboItems.isActive, hide: isClickHeader }"
  >
    <div class="show-open-list">
      <div class="search-filter-container">
        <div class="search-input-wrap">
          <input
            type="text"
            class="search-input"
            v-model="searchText"
            :placeholder="$t('chart1.searchCoin')"
          />
          <img src="@/assets/images/icons/search_ico.svg" class="search-icon" />
        </div>

        <button
          :class="[`btn favorite_btn`, { active: isFavoriteList }]"
          @click="getFavoriteList"
        >
          {{ useDevice().isMobile ? "" : $t("chart1.favoritesList") }}
        </button>
      </div>

      <ul class="list-wrap" v-if="comboItems.items && comboItems.items.length">
        <li
          v-for="item in isFavoriteList ? favoriteItems : filteredItems"
          :key="item.key"
        >
          <p class="coin-list-wrap">
            <img
              :src="item.selected ? StarFull : Star"
              alt=""
              @click="setFavoriteCoin(item.key)"
            />
            <span class="coin-symbol-wrap" @click="listClickHandler(item)">
              <img
                :src="item.icon ? item.icon : NotAllow"
                class="coin-symbol"
                alt="coin icon"
              />
              {{ item.value }}
            </span>
          </p>
        </li>
      </ul>
    </div>
    <div v-if="comboItems.isActive" class="select-close" @click="openHandler">
      <img src="@/assets/images/icons/arrow_top_ico.svg" class="select-ico" />
    </div>
  </section>
</template>

<script setup>
import { defineEmits, defineProps, ref, computed, reactive, watch } from "vue";
import Star from "@/assets/images/components/tabulator/star.svg";
import StarFull from "@/assets/images/components/tabulator/starFull.svg";
import NotAllow from "@/assets/images/icons/not_allowed_ico.svg";
import { setFavoriteCoinList } from "@/utils/user/user_api.js";

const emit = defineEmits(["onClick"]);

const props = defineProps({
  comboItems: {
    type: Object,
    default: () => ({
      isActive: false,
      title: "Select Coins",
      titleStyle: {},
      items: [],
    }),
  },
});

const comboItems = ref(props.comboItems); // Use reactive for deep reactivity
watch(
  () => props.comboItems,
  (newVal) => {
    comboItems.value = newVal;
  },
  { deep: true }
);

const useDevice = () => {
  return window.innerWidth > 768 ? { isMobile: false } : { isMobile: true };
};

const searchText = ref("");
const isFavoriteList = ref(false);

const favoriteItems = computed(() => {
  if (!comboItems.value.items) return [];

  const filterLowerCase = searchText.value.toLowerCase();
  const selectedItem = comboItems.value.items.filter((ob) => ob.selected);

  return selectedItem.filter((option) =>
    option.value.toLowerCase().includes(filterLowerCase)
  );
});

const filteredItems = computed(() => {
  if (!comboItems.value.items) return [];

  const filterLowerCase = searchText.value.toLowerCase();
  return comboItems.value.items.filter((option) =>
    option.value.toLowerCase().includes(filterLowerCase)
  );
});

const updateSearchText = (event) => {
  searchText.value = event.target.value;
};

const listClickHandler = (item) => {
  emit("onClick", {
    selected: item.key,
  });
};

// const chartTypeRadioList = ref([
//     {key: 'spot',    value: "Spot",     checked: false,  name: "charttype"},
//     {key: 'future',  value: "Future",   checked: true,   name: "charttype"},
// ]);

// const chartTypeRadioHandler = (res) => {
//     chartType.value = res.selected.key;
// }

const setFavoriteCoin = async (coinName) => {
  const { status, error } = await setFavoriteCoinList({ coinName });
  if (error) {
    return;
  }

  if (status) {
    comboItems.value.items.forEach((ob) => {
      if (ob.key === coinName) ob.selected = !ob.selected;
    });
  }
};

const getFavoriteList = (e) => {
  isFavoriteList.value = !isFavoriteList.value;
};

let isClickHeader = ref(false);
const openHandler = (e) => {
  comboItems.value.isActive = comboItems.value.isActive ? false : true;
  isClickHeader.value = !comboItems.value.isActive;
};

function getFilteredItem() {
  const filterLowerCase = searchText.value.toLowerCase();
  return comboItems.value.items.filter((option) =>
    option.value.toLowerCase().includes(filterLowerCase)
  );
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/components/ui/radioSlide.scss";
</style>
